import Axios, { AxiosError } from "axios";
import { ErrorCode } from "config/constants";
import CustomError from "models/CustomError";

const HttpErrorCodeToErrorCodeMap = {
    "403": ErrorCode.forbidden,
    "404": ErrorCode.notFound,
    "500": ErrorCode.systemError,
    "409": ErrorCode.conflict,
    "422": ErrorCode.unprocessableEntity,
    "423": ErrorCode.locked,
}

export default class ErrorHandler {
    static handleHttpError(e: any): never {
        if(e instanceof CustomError) throw e
        if (Axios.isCancel(e)) {
            throw new CustomError({
                code: ErrorCode.requestCanceled,
            })
        }
        if (e.isAxiosError) {
            const error = e as AxiosError<any>
            throw new CustomError({
                code: error.response && HttpErrorCodeToErrorCodeMap.hasOwnProperty(error.response.status)
                    ? HttpErrorCodeToErrorCodeMap[error.response.status]
                    : ErrorCode.unknownError,
                payload: error.response?.status === 422 && error.response.data.errors ? error.response.data.errors : undefined,
            })
        }
        console.log(e)
        throw new CustomError({
            code: ErrorCode.unknownError,
        })
    }
}
